import React from 'react'
import { Flex, Label, Button, Table, InfoIcon, Span } from '@fareye/ui'
import { FaDownload, isEmpty, dMmm } from '@fareye/utils'
import { getTableColumns } from './Column'
import { formatForCSV } from '../../../utility/function'
import { downloadToCSV, useTranslation } from '@fareye/common'
import { tripTabsBackground, modeBackground } from '@fareye/configs'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px',
    height: 'fit-content'
  },
  downloadIcon: {
    marginLeft: '8px'
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: modeBackground,
    width: 'fit-content',
    marginBottom: '8px'
  }
}
export const EPOD = ({ data, config }: any) => {
  const { epodDetail = {}, packageDetails = [] } = data
  const { t } = useTranslation()
  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const {
    config: { ePODColumns }
  } = config
  const selectedColumn = React.useMemo(() => {
    return getTableColumns(ePODColumns, {
      t,
      queryParams: {}
    })
  }, [])
  const displayData = isEmpty(packageDetails)
    ? [epodDetail]
    : packageDetails
        .map((item: any) => {
          return { ...item.epodDetail }
        })
        .filter((item: any) => !isEmpty(item))
  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Flex justifyContentSpaceBetween>
          <Label
            style={{ fontSize: '16px', fontWeight: 600, marginTop: '6px' }}
          >
            EPOD
          </Label>
          <Flex>
            <Button
              disabled={isEmpty(displayData)}
              isLoading={false}
              variant="s primary"
              style={{ height: '30px' }}
              onClick={() => {
                setDownloadLoading(true)
                downloadToCSV({
                  data: formatForCSV(displayData, ePODColumns),
                  options: { header: false },
                  fileName: `epod${dMmm()}`
                })
                setDownloadLoading(false)
              }}
            >
              {t('Download CSV')}
              <FaDownload style={style.downloadIcon} />
            </Button>
          </Flex>
        </Flex>
      </Flex>
      {!isEmpty(displayData) ? (
        <Flex style={style.tripTabs} column>
          <Table
            className="striped responsive"
            totalElements={displayData.length}
            sortable={false}
            showTotalCount={false}
            showPagination={false}
            data={displayData}
            columns={selectedColumn}
            style={{ table: { tableLayout: 'auto', width: 'max-content', minWidth: '100%' } }}
          />
        </Flex>
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('No Data')}
        </Label>
      )}
    </Flex>
  )
}
